import React from 'react'
import { motion } from 'framer-motion'
import { useNavigate, useLocation } from 'react-router-dom'
import { FaUsers, FaClipboardList, FaUserTie, FaUserShield } from 'react-icons/fa'
import '../assets/css/Sidebar.css'
import { RiUser2Fill } from 'react-icons/ri'
import { MdSpaceDashboard } from 'react-icons/md'

function AdminSidebar() {
  const navigate = useNavigate()
  const location = useLocation()

  const adminMenuItems = [
    {
      id: '4',
      name: 'Dashboard',
      icon: <MdSpaceDashboard />,
      path: '/admin-dashboard'
    },
    {
      id: '1',
      name: 'Finnance / Accounts Users',
      icon: <FaUserTie />,
      path: '/admin/finnnance-accounts-users'
    },
    {
      id: '3',
      name: 'SAE Users',
      icon: <RiUser2Fill />,
      path: '/admin/users'
    },
    
    {
      id: '2',
      name: 'Allotment',
      icon: <FaClipboardList />,
      path: '/admin/allotment'
    }
  ]

  const handleItemClick = (path) => {
    navigate(path)
  }

  return (
    <div className="sidebar">
      <ul className="sidebar-menu">
        {adminMenuItems.map((item, index) => (
          <motion.li
            key={item.id}
            className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => handleItemClick(item.path)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
          >
            <span className="icon">{item.icon}</span>
            <span className="text">{item.name}</span>
          </motion.li>
        ))}
      </ul>
    </div>
  )
}

export default AdminSidebar
